import("./bootstrap").then(({ mount }) => {
    const localRoot = document.getElementById("account-list-mfe-ui");

    mount({
        mountPoint: localRoot as HTMLElement,
        routingStrategy: "browser"
    });
});
